import {createContext, useContext} from "react";
import {IApiEndpoint, IOperationResponse} from "@localization/siteMap/siteMapInterfaces.ts";

type ApiContextType = {
    Get: <T>(endpoint: IApiEndpoint<T>, ignoreCache?: boolean, ignoreLoading?: boolean) => Promise<IOperationResponse<T>>;
    GetSync: <T>(endpoint: IApiEndpoint<T>, ignoreCache?: boolean, abortSignal?: AbortSignal) => Promise<Response>;
    GetFile: <T>(endpoint: IApiEndpoint<T>) => Promise<Blob>;
    // Funções para reatividade seletiva
    getPromises: () => (Promise<Response> & { status?: any, timestamp?: number })[];
    subscribeToPromises: (callback: () => void) => () => void;
}

export const ApiContext = createContext<ApiContextType | null>(null);
/**
 * @see ApiProvider
 * @see useApiPromises
 * @see useApiHealthStatus
 * @returns {ApiContextType}
 */
export const useApi = () => {
    const context = useContext(ApiContext);
    if (!context) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};